module.exports = __webpack_public_path__ + "img/training-icon.8237921e.svg";